<template>
  <div class="my-evaluation">
    <!-- <ExamAttrSetting class="attr" pos="right" @save="onAttrSave"></ExamAttrSetting> -->
    <el-tabs class="el-tabs-common" v-model="curTab">
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :name="item.name"
        :label="item.label"
      ></el-tab-pane>
    </el-tabs>
    <MemberEvaluationTest
      ref="test"
      v-if="curTab == 'test'"
    ></MemberEvaluationTest>
    <MemberEvaluationMistake
      ref="mistake"
      v-else-if="curTab == 'mistake'"
    ></MemberEvaluationMistake>
    <MemberEvaluationCollect
      ref="collect"
      v-else-if="curTab == 'collect'"
    ></MemberEvaluationCollect>
  </div>
</template>

<script>
import MemberEvaluationTest from "./MemberEvaluationTest";
import MemberEvaluationMistake from "./MemberEvaluationMistake";
import MemberEvaluationCollect from "./MemberEvaluationCollect";
import { triggerLoaded } from "@/components/LoadContainer.vue";
// import ExamAttrSetting from "../exam/components/ExamAttrSetting";
export default {
  name: "my-evaluation",
  components: {
    MemberEvaluationTest,
    MemberEvaluationMistake,
    MemberEvaluationCollect,
    // ExamAttrSetting
  },
  data() {
    return {
      tabs: [
        { name: "test", label: "练习记录" },
        { name: "mistake", label: "错题集" },
        { name: "collect", label: "收藏夹" },
      ],
      curTab: this.$route.query.tab || "test",
    };
  },
  created() {
    triggerLoaded(this);
  },
  methods: {
    onAttrSave() {
      if (this.$refs.test) {
        this.$refs.test.getData();
      } else if (this.$refs.mistake) {
        this.$refs.mistake.getData();
      } else if (this.$refs.collect) {
        this.$refs.collect.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-evaluation {
  padding: 5px 24px 20px 24px;
  background: #fff;
  position: relative;
  .attr {
    position: absolute;
    top: -63px;
    right: 15px;
  }
}
</style>
